export default "__VITE_ASSET__D_mtYE4q__"